import React from "react";
import { FormattedMessage } from "react-intl";

const IntlMessage = (props) => (
  <FormattedMessage {...props} />
);

export default IntlMessage;